import predicates from '../predicates'
import { APP_TRAFFIC_ID, APP_TRAFFIC_SOURCE } from '../constants'

const app = {
  rule: predicates.searchParamEqualsOne('app', '1'),
  extractor: traffic => {
    const trafficSource = APP_TRAFFIC_SOURCE
    const trafficId = APP_TRAFFIC_ID

    return {
      trafficSource,
      trafficId,
    }
  },
}

export default app



// WEBPACK FOOTER //
// ./provolution/app/views/provolution/jsCore/organizedByType/services/trafficAnalyzer/pipelines/app.js